import { render, staticRenderFns } from "./WidgetNode.vue?vue&type=template&id=3dfb0c4c&scoped=true&"
import script from "./WidgetNode.vue?vue&type=script&lang=js&"
export * from "./WidgetNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb0c4c",
  null
  
)

export default component.exports